/**************************************/
/*****250731_新規作成（報告書№2288）*****/
/**************************************/ 

document.addEventListener("DOMContentLoaded", function () {
  const pageTopBtn = document.querySelector(".page-top");

  // 初期状態は非表示
  pageTopBtn.style.opacity = "0";
  pageTopBtn.style.transition = "opacity 0.5s ease";

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      pageTopBtn.style.opacity = "1";
    } else {
      pageTopBtn.style.opacity = "0";
    }
  });

  pageTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

});
  //商品ページもっとみるボタン追加
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById("toggle-btn");
  const description = document.getElementById("product-description");

  if (toggleBtn && description) {
    const threshold = 100;
    const textLength = description.textContent.trim().length;

    if (textLength > threshold) {
      // 文字数が多い場合にのみボタンを表示
      toggleBtn.style.display = "flex"; // or "block" など必要に応じて
      toggleBtn.addEventListener("click", function () {
        description.classList.toggle("expanded");
        toggleBtn.textContent = description.classList.contains("expanded") ? "閉じる" : "もっと見る";
      });
    }
  } 
  // else {
  //   console.log("要素が見つかりません");
  // }
});
